module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-items"
  }, [_c('div', {
    staticClass: "columns is-multiline is-mobile"
  }, [(_vm.person.isMe) ? _c('div', {
    staticClass: "column is-one-third"
  }, [_c('router-link', {
    staticClass: "button sui-contribute-new-item",
    attrs: {
      "to": {
        name: 'Contribute'
      },
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])]), _vm._v(" "), _c('p', [_vm._v("\n            ADD ITEM\n          ")])])])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.itemList), function(item) {
    return [_c('div', {
      staticClass: "column is-one-third"
    }, [_c('div', {
      staticClass: "image is-1by1",
      on: {
        "click": function($event) {
          _vm.openModal(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.content
      }
    })])])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: _vm.modalClass
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "image is-1by1"
  }, [_c('img', {
    attrs: {
      "src": _vm.modalData.content
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n              Some " + _vm._s(_vm.modalData.type) + "\n            ")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_c('small', [_vm._v("\n                Curator: " + _vm._s(_vm.modalData.owner.name) + "\n                "), _c('br'), _vm._v("\n                ImageId: " + _vm._s(_vm.modalData.itemId) + "\n              ")])]), _vm._v(" "), _c('p', [_c('small', [_vm._v("\n                " + _vm._s(_vm.modalData.caption) + "\n              ")])])])])])]), _vm._v(" "), _c('button', {
    staticClass: "modal-close",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-5c87baa8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfileItems.vue
// module id = 284
// module chunks = 1